import type {
  UtilizationReportDataSource,
  UtilizationReportGroupBy,
} from "@src/__generated__/urql-graphql";
import type { UtilizationReportBaseStore } from "@src/components/modules/reports/utilization/stores/base-store";
import { getParamFromQuery } from "@src/utils/url";
import { useRouter } from "next/router";
import { useLayoutEffect } from "react";

export function useUtilizationFiltersFromQuery(
  store: UtilizationReportBaseStore,
) {
  const { query } = useRouter();

  useLayoutEffect(() => {
    if (!query) return;

    const from = getParamFromQuery("from", query);
    const to = getParamFromQuery("to", query);
    const dataSource = getParamFromQuery("dataSource", query);

    if (from && to) {
      store.dateRange.start = new Date(from);
      store.dateRange.end = new Date(to);
    }
    store.groupBy = getParamFromQuery("groupBy", query) as
      | UtilizationReportGroupBy
      | undefined;

    if (dataSource) {
      store.dataSource = dataSource as UtilizationReportDataSource;
    }

    store.pagination.fromURLSearchParam(query);
    store.where.fromURLSearchParam(query);
    store.orderBy.fromURLSearchParam(query);
    store.orderByGrouped.fromURLSearchParam(query);
  }, []);
}
